import {Component, EventEmitter, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from '../../core/services/header.service';
import {ActivatedRoute} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {AuthService} from '../../core/security/auth.service';
import {ReportsService} from '../reports.service';
import * as _ from 'lodash';
import {MatDialog} from '@angular/material/dialog';
import {GroupsSummaryV2GridComponent} from './groups-summary-v2-grid/groups-summary-v2-grid.component';
import {BaseComponent} from '../../core/base.component';
import {SelectedFilterValuesModel} from '../../dialogs/grid-filter/selected-filter-values.model';
import {FilterOptionModel} from '../../dialogs/grid-filter/filter-option.model';
import {GroupsSummaryFilterDialogComponent} from '../shared/groups-summary-filter-dialog.component';
import {DateRangeService} from '../../core/services/date-range.service';
import {GroupsReportsService as GroupsReportsApiService} from '../../api/services/groups-reports.service';
import {catchError, finalize} from 'rxjs/operators';
import {of} from 'rxjs';
import {GroupAgentsSummaryResponse} from '../../api/models/group-agents-summary-response';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressBar } from '@angular/material/progress-bar';
import { GridFilterComponent } from '../../dialogs/grid-filter/grid-filter.component';
import { FilterRowAdditionalContentComponent } from '../../dialogs/grid-filter/filter-row-additional-content.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatCard, MatCardContent } from '@angular/material/card';
import { ChartByGroupV2Component } from './charts/chart-by-group-v2.component';
import { ChartByGroupAgentsV2Component } from './charts/chart-by-group-agents-v2.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-groups-summary-v2',
    templateUrl: './groups-summary-v2.component.html',
    styles: [
        '.column-chart {height: 375px; position: relative}'
    ],
    standalone: true,
    imports: [FlexModule, NgIf, MatProgressBar, GridFilterComponent, FilterRowAdditionalContentComponent, MatButton, MatIcon, MatCard, MatCardContent, ChartByGroupV2Component, ChartByGroupAgentsV2Component, MatProgressSpinner, GroupsSummaryV2GridComponent, AsyncPipe]
})
export class GroupsSummaryV2Component extends BaseComponent implements OnDestroy, OnInit {

  filterChangeEvent = new EventEmitter<any>();
  selectedFilterChange = new EventEmitter<SelectedFilterValuesModel[]>();

  selectedFilter: SelectedFilterValuesModel[] = new Array<SelectedFilterValuesModel>();
  filterOptions: FilterOptionModel[] = [];

  additionalFilter: any = {};
  exportColumns: any[] = [];

  groupSeriesTotals: any = [];
  groupSeriesAvgTotals: any = [];

  agentSeriesTotals: any = [];
  agentSeriesAvgTotals: any = [];

  selectedGroup = '';
  isLoadingAgentsData = false;

  @ViewChild('groupsSummaryGrid', {static: true}) groupsSummaryGrid: GroupsSummaryV2GridComponent;

  constructor(public reportsService: ReportsService,
              public dateRangeService: DateRangeService,
              public dialog: MatDialog,
              private groupsReportsApiService: GroupsReportsApiService,
              route: ActivatedRoute, public headerService: HeaderService, titleService: Title, authService: AuthService) {
    super(route, headerService, titleService, authService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.headerService.hideSearchInput();

    if (this.reportsService.accountsLookup?.length > 0) {
      this.initFilterOptions();
    } else {
      this.reportsService.lookupUpdatedEvent.subscribe(() => {
        this.initFilterOptions();
      });
    }

    this.groupsSummaryGrid.dataSource.dataSubject.subscribe(data => {
      this.groupSeriesTotals = data.map(x => {
        return {
          extension: x._id,
          answeredCalls: Number(x.answered || 0),
          canceled: Number(x.missed || 0),
        };
      });

      this.groupSeriesAvgTotals = data.map(x => {
        return {
          extension: x._id,
          avgTalkDuration: Number(x.avgDurationTalk),
          totalTalkDuration: Number(x.durationTalk),
          avgRingDuration: Number(x.avgDurationRing),
        };
      });

      if (data?.length > 0) {
        let group = this.selectedGroup;
        if (group) {
          const exist = data.find(x => x._id === group);
          if (!exist) {
            group = data[0]._id;
          }
        } else {
          group = data[0]._id;
        }
        this.loadAgentsData(group);
      }

      if (data?.length === 0) {
        this.agentSeriesTotals = [];
        this.agentSeriesAvgTotals = [];
      }
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  async openExportDialog() {
    await this.groupsSummaryGrid.onExportClick();
  }

  openFilterDialog() {
    console.log('open filter dialog');
    const dialogRef = this.dialog.open(GroupsSummaryFilterDialogComponent, {
      width: '500px',
      height: '90%',
      data: {
        filter: this.selectedFilter
      }
    });

    dialogRef.afterClosed().subscribe(async (result: SelectedFilterValuesModel[]) => {
      if (result) {
        this.selectedFilterChange.emit(result);
      }
    });
  }

  onSelectedItemsChanged($event: SelectedFilterValuesModel[]) {
    this.selectedFilter = $event;
  }

  onFilterChanged(filter: any) {
    let accounts = [];

    if (filter['agentGroup']) {
      accounts = _.union(accounts, filter['agentGroup']);
      filter['agentGroup'] = undefined;
    }
    if (filter['huntGroup']) {
      accounts = _.union(accounts, filter['huntGroup']);
      filter['huntGroup'] = undefined;
    }

    filter['groupAccounts'] = accounts;

    this.additionalFilter = filter;
    this.filterChangeEvent.emit(filter);
  }

  initFilterOptions(): void {
    this.filterOptions = [
      {
        filterKey: 'searchText',
        multiValue: false,
        showAlways: true,
        type: 'string',
        title: 'Any'
      },
      {
        filterKey: 'groupTypes',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Type',
        displayValue: 'Agents Group',
        value: 'acd',
        searchText: 'Type: Agents Group',
      },
      {
        filterKey: 'groupTypes',
        multiValue: true,
        showAlways: false,
        type: 'static',
        title: 'Type',
        displayValue: 'Hunt Group',
        value: 'hunt',
        searchText: 'Type: Hunt Group',
      },
    ];

    if (this.reportsService.groupsLookup.length > 0) {
      for (const item of this.reportsService.groupsLookup) {
        this.filterOptions.push({
          filterKey: 'agentGroup',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Agent Group',
          displayValue: item.text,
          value: item.value,
          searchText: `Agent Group: ${item.text}`,
        });
      }
    }

    if (this.reportsService.huntGroupsLookup.length > 0) {
      for (const item of this.reportsService.huntGroupsLookup) {
        this.filterOptions.push({
          filterKey: 'huntGroup',
          multiValue: true,
          showAlways: false,
          type: 'static',
          title: 'Hunt Group',
          displayValue: item.text,
          value: item.value,
          searchText: `Hunt Group: ${item.text}`,
        });
      }
    }
  }

  loadAgentsData(group: string) {
    this.selectedGroup = group;

    this.isLoadingAgentsData = true;
    this.groupsReportsApiService
      .groupsSummaryV2GetAgentsSummaryData({
        body: {
          filter: {
            domain: this.reportsService.selectedDomain,
            startDate: this.additionalFilter.startDate,
            endDate: this.additionalFilter.endDate,
            group: this.selectedGroup,
            extensions: []
          }
        }
      })
      .pipe(
        catchError(() => of({data: [], total: 0})),
        finalize(() => this.isLoadingAgentsData = false)
      )
      .subscribe((response: GroupAgentsSummaryResponse) => {
        const data = response.data;
        if (!data) {
          return;
        }

        this.agentSeriesTotals = data.map(x => {
          return {
            extension: x.extension,
            answeredCalls: Number(x.totalAnswered || 0),
            canceled: Number(x.totalMissed || 0),
          };
        });

        this.agentSeriesAvgTotals = data.map(x => {
          return {
            extension: x.extension,
            avgTalkDuration: Number(x.avgDurationTalk),
            totalTalkDuration: Number(x.totalDurationTalk),
            avgRingDuration: Number(x.avgDurationRing),
          };
        });

      });

  }

  onGroupSelected($event: string) {
    console.log($event);
    if (this.selectedGroup === $event) {
      return;
    }

    this.loadAgentsData($event);
  }
}
